<script setup>
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { useAllTranslations } from '@/static/messageBylanguages.js';
import { useCallStore } from '@/stores/call.ts';
import { QRCodeType } from '@/stores/chat.ts';

const route = useRoute();
const router = useRouter();
const callStore = useCallStore();
const translations = useAllTranslations();

const type = ref(null);
const firstMessage = ref('');
const secondMessage = ref('');
const buttonName = ref(null);

const handleClick = () => {
  router.push({
    name: 'chat-entrance',
    params: {
      code: callStore.qrCodeInfo.code,
    },
  });
};

onMounted(() => {
  const errorCode = localStorage.getItem('errorCode');
  if (errorCode === '1027') {
    // 이미 종료된 통역
    firstMessage.value = translations.alert_ended_or_deleted_interpretation.value;
    secondMessage.value = translations.alert_thank_you_using_sconchat.value;
  } else if (errorCode === '1016') {
    firstMessage.value = translations.alert_bad_request.value;
  } else if (errorCode === '1026') {
    if (QRCodeType.isConsultationType(callStore.qrCodeInfo.qrCodeType)) {
      firstMessage.value = translations.alert_already_interpreting.value;
      secondMessage.value = translations.alert_thank_you_using_sconchat.value;
    } else {
      firstMessage.value = translations.alert_exceeded_max_participants.value;
      secondMessage.value = translations.alert_confirm_move_to_access_screen.value;
      buttonName.value = translations.button_move.value;
    }
  }
});
</script>

<template>
  <div class="container">
    <img :src="'/images/logo-sconchat-full.png'" alt="logo-sconai" class="logo-sconai" />
    <p>
      {{ firstMessage }}
      <br />
      {{ secondMessage }}
    </p>
    <button v-if="buttonName" @click="handleClick" class="button-primary">
      {{ buttonName }}
    </button>
    <div class="info-sconai">
      <p class="smaller">Provided with</p>
      <p class="smaller-semibold">SconAI</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 30rem;
  height: calc(100dvh);
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: auto;
  padding: 2rem;
  padding-bottom: 4rem;
  gap: 2rem;
}

.info-sconai {
  display: flex;
  gap: 0.2rem;
  color: var(--font-dim);
  text-wrap: nowrap;
}

.logo-sconai {
  width: 12rem;
}
</style>
